import { createApp } from 'vue';
import { createPinia } from 'pinia';
import 'material-icons/iconfont/material-icons.css';
import './styles/theme.css';
import { applyThemeToBody, readStoredTheme } from './utils/theme';
import App from './App.vue';
import router from './router';

applyThemeToBody(readStoredTheme());

// Ajouter les fonts Material Icons Outlined
const link = document.createElement('link');
link.rel = 'stylesheet';
link.href = 'https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200';
document.head.appendChild(link);

const app = createApp(App);

// Gestion globale des erreurs non capturées
app.config.errorHandler = (err, _instance, info) => {
  if (import.meta.env.DEV) {
    console.error('[Global Error Handler]', {
      error: err,
      info,
    });
  }
  // En production, on pourrait envoyer l'erreur à un service de logging
};

// Gestion des warnings
app.config.warnHandler = (msg, _instance, trace) => {
  if (import.meta.env.DEV) {
    console.warn('[Vue Warning]', msg, trace);
  }
};

app.use(createPinia());
app.use(router);

app.mount('#app');
